export const signIn = (credentials) => {
  return (dispatch, getState, { getFirebase }) => {
    try {
      const firebase = getFirebase();
    
    var user=firebase.auth().signInWithEmailAndPassword(
      credentials.email,
      credentials.password
    ).then(() => {
      dispatch({ type: 'LOGIN_SUCCESS' });
      
    }).catch((err) => {
      dispatch({ type: 'LOGIN_ERROR', err });
    });
    if(user.emailVerified)
    {
      dispatch({ type: 'LOGIN_SUCCESS'});
    }
    else
    {
      getFirebase().auth().signOut().then(() => {
        const err={message:'Please Verify your Email Address'}
      
      throw err;
      })
      
    }
  }
  catch(err){
    
    return dispatch({ type: 'LOGIN_ERROR',err});
  }
    
    

  }
}

export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase.auth().signOut().then(() => {
      dispatch({ type: 'SIGNOUT_SUCCESS' })
    }).catch((err) => {
      dispatch({ type: 'SIGNOUT_ERROR', err });
    });
  }
}

export const signUp = (newUser) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    if (newUser.isCounselor) {
      firebase.auth().createUserWithEmailAndPassword(
        newUser.email,
        newUser.password
      )
        .then(resp => {
          return firestore.collection('users').doc(resp.user.uid).set({
            id: resp.user.uid,
            username: newUser.username,
            from: newUser.from,
            to: newUser.to,
            isCounselor:newUser.isCounselor
          });
        }).then(() => {
          dispatch({ type: 'SIGNUP_SUCCESS' });
        }).catch((err) => {
          dispatch({ type: 'SIGNUP_ERROR', err });
        });
    }
    else {
      firebase.auth().createUserWithEmailAndPassword(
        newUser.email,
        newUser.password
      )
        .then(resp => {
          resp.user.sendEmailVerification().then(function() {
            // Email sent.
            return firestore.collection('users').doc(resp.user.uid).set({
              id: resp.user.uid,
              email:newUser.email,
              username: newUser.username,
              gender: newUser.gender,
              age: newUser.age,
              
              qualification: newUser.qualification,
              occupation: newUser.occupation,
              familymembers: newUser.familymembers,
              relationshipstatus: newUser.relationshipstatus,
              livingsituation: newUser.livingsituation,
              livingwith: newUser.livingwith,
              isFirsttime: newUser.isFirsttime,
              listofpasttherapy: newUser.listofpasttherapy,
              isCounselor:newUser.isCounselor
            });
          }).catch(function(error) {
            // An error happened.
            dispatch({ type: 'SIGNUP_ERROR', error });
          });


          
        }).then(() => {
          dispatch({ type: 'SIGNUP_SUCCESS' });
        }).catch((err) => {
          dispatch({ type: 'SIGNUP_ERROR', err });
        });
    }
  }



}
// Reset password with Firebase
export const resetPassword = email => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    try {
      const firebase = getFirebase();
      firebase
        .auth()
        .sendPasswordResetEmail(email)
        .then(() =>
          dispatch({
            type: 'RESET_SUCCESS',
            payload: "Reset email sent. Go check your inbox."
          })
        )
        .catch(err => {
          dispatch({
            type: 'RESET_ERROR',
            payload: "...some message for the user..."
          });
        });
    } catch (err) {
      dispatch({
        type: 'RESET_ERROR',
        payload: "...some message for the user..."
      });
    }
  }
};